import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getTicketFiles, uploadTicketFiles, deleteTicketFile, downloadTicketFile, viewTicketFile } from "../../api/TICKET/ticketFiles";

const filesKey = (ticketId) => ["ticketFiles", ticketId];

export const useTicketFiles = (ticketId) =>
  useQuery({
    queryKey: filesKey(ticketId),
    queryFn: () => getTicketFiles(ticketId),
    enabled: !!ticketId,
    staleTime: 2 * 60 * 1000,
    select: (data) => {
      const files = data.data ?? [];
      return Array.isArray(files) ? files : [];
    },
  });

export const useUploadTicketFile = (ticketId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file) => uploadTicketFiles(ticketId, file),
    onSuccess: () => qc.invalidateQueries({ queryKey: filesKey(ticketId) }),
  });
};

export const useDeleteTicketFile = (ticketId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (fileId) => deleteTicketFile(ticketId, fileId),
    onSuccess: () => qc.invalidateQueries({ queryKey: filesKey(ticketId) }),
  });
};

export const useDownloadTicketFile = (ticketId) => {
  return {
    download: (fileId, filename) => downloadTicketFile(ticketId, fileId, filename),
    view: (fileId) => viewTicketFile(ticketId, fileId)
  };
};
